import { Suspense, lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { SearchProvider } from './hooks/useSearch';
import Layout from './components/layout/Layout';
import HomePageSkeleton from './components/common/HomePageSkeleton';
import ToolPageSkeleton from './components/common/ToolPageSkeleton';
import { ErrorBoundary, ToastProvider } from '@lab39/react-ui';
import { icons } from './data/icons';
import '@lab39/react-ui/dist/react-ui.css';
import './App.css';

const Home = lazy(() => import('./components/Home'));
const ToolPage = lazy(() => import('./components/ToolPage'));
const NotFound = lazy(() => import('./components/error/NotFound'));
const ServerError = lazy(() => import('./components/error/ServerError'));

function AppRoutes() {
  const location = useLocation();
  const isToolPage = location.pathname.startsWith('/tools/');
  
  return (
    <Suspense fallback={isToolPage ? <ToolPageSkeleton /> : <HomePageSkeleton />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tools/:toolId" element={<ToolPage />} />
        <Route path="/error" element={<ServerError />} />
        <Route path="/about" element={<NotFound />} />
        <Route path="/privacy" element={<NotFound />} />
        <Route path="/terms" element={<NotFound />} />
        <Route path="/contact" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <SearchProvider>
          <ToastProvider
            icons={{
              success: icons.success,
              error: icons.error,
              warning: icons.warning,
              info: icons.info
            }}
          >
            <Layout>
              <AppRoutes />
            </Layout>
          </ToastProvider>
        </SearchProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;